// A single dt/dd row used inside grid layouts. Kept tiny so the split
// cards stay readable.
export function Field({ label, value, dataTestId }) {
  return (
    <div>
      <dt className="text-[11px] uppercase tracking-wide text-slate-500 font-display">
        {label}
      </dt>
      <dd className="text-slate-900 text-sm font-mono-num" data-testid={dataTestId}>
        {value ?? "—"}
      </dd>
    </div>
  );
}
